import { Component } from '@angular/core';
import { IonicPage, NavController,AlertController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import { LoginPage } from '../login/login';

/**
 * Generated class for the CreateNewPasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-create-new-password',
  templateUrl: 'create-new-password.html',
})
export class CreateNewPasswordPage {

  mobile:any="";
  password:any="";
   errorDisplay:any={};
  constructor(
    private loadingCtrl:LoadingController,
    private fv:GenericFormValidationProvider,
    private alertCtrl:AlertController, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
    this.mobile=this.navParams.get("mobile")
  }

  ionViewDidLoad() {
    ////console.log('ionViewDidLoad CreateNewPasswordPage');
  }
  postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[])
    if(this.errorDisplay.valid){
     return false;
   }else{
  let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
  loading.present();
    this.cp.updatePassword(loading,this.password,this.mobile).then((res:any)=>{
      loading.dismiss();
      var res=JSON.parse(res)
      // //console.log(res,"create")
       if(res.Payload.Message=="SUCCESS"){
        this.showAlert("SUCCESS","Password created successfully");
         // alert("password create successfully");
         this.navCtrl.setRoot(LoginPage)
         
       }
    }).catch((err:any)=>{////console.log("invalid");
    })
   }
   }
   showAlert(title,msg) {

      let masg=msg;
      const alert = this.alertCtrl.create({
        title: title,
        subTitle: masg,
        buttons: ['OK']
      });
      alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/create-new-password/create-new-password.ts